<app-header />
<div class="consultancy">
  <div class="bg_img consultancy_top">
    <div class="consultancy_top_hamburger">
      <div class="hamburger-icon consultancy_top_hamburger_icon" (click)="toggleMenu()">
        <img src="../../../assets/icons/hamburger.png" alt="Menu" />
      </div>
      <div class="consultancy_top_hamburger_content" [ngClass]="{ open: isMenuOpen }">
        <div class="width-100-per consultancy_top_hamburger_content_box">
          <div class="width-100-per">
            <div class="bottom-border-3 cursor-pointer p-x-20 consultancy_top_hamburger_content_box_item"
              routerLink="/patent-india">
              <div class="p-y-18">
                <span>Patent Service</span>
              </div>
            </div>
            <div class="cursor-pointer p-x-20 consultancy_top_hamburger_content_box_item" routerLink="/agro-regulatory">
              <div class="p-y-18">
                <span>Regulatory Service</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let heading of head">
      <div class="text-center inline_padding2 consultancy_top_content" *ngIf="heading.page === currentPage">
        <div class="inline_padding3">
          <span class="text_style_5"> Consulting Solutions </span>
        </div>
        <div class="inline_padding3 p-top-16">
          <span class="text_black_4_res" [innerHtml]="heading.page_sub_heading"></span>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="consultancy_bottom inline_padding1">
    <div class="consultancy_bottom_left">
      <ng-container *ngFor="let patent of patentContent">
        <div class="consultancy_bottom_content">
          <div class="consultancy_bottom_content_box">
            <div class="consultancy_bottom_content_box_left">
              <img [src]="imageBaseUrl + patent.image" alt="{{ patent.header_title }}"
                class="consultancy_bottom_content_box_left_img" />
            </div>
            <div class="consultancy_bottom_content_box_center p-x-40">
              <div>
                <span class="text_blue_10" [innerHtml]="patent.header_title"></span>
              </div>
              <div class="share-buttons" style="margin-top: 15px">
                <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fas fa-link" style="color: #000"></i>
                  <!-- Copy Link -->
                </button>
                <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fas fa-envelope" style="color: #ea4335"></i>
                  <!-- Email -->
                </button>
                <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fas fa-sms" style="color: #25d366"></i>
                  <!-- SMS -->
                </button>
                <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-whatsapp" style="color: #25d366"></i>
                  <!-- WhatsApp -->
                </button>
                <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-facebook-messenger" style="color: #0084ff"></i>
                  <!-- Messenger -->
                </button>
                <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-viber" style="color: #59267c"></i>
                  <!-- Viber -->
                </button>
                <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-facebook" style="color: #4267b2"></i>
                  <!-- Facebook -->
                </button>
                <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-twitter" style="color: #1da1f2"></i>
                  <!-- Twitter -->
                </button>
                <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-linkedin" style="color: #0077b5"></i>
                  <!-- LinkedIn -->
                </button>
                <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-pinterest" style="color: #e60023"></i>
                  <!-- Pinterest -->
                </button>
                <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-reddit" style="color: #ff4500"></i>
                  <!-- Reddit -->
                </button>
                <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-tumblr" style="color: #35465c"></i>
                  <!-- Tumblr -->
                </button>
                <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-telegram" style="color: #0088cc"></i>
                  <!-- Telegram -->
                </button>
                <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-vk" style="color: #4b7be5"></i>
                  <!-- VK -->
                </button>
                <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-mix" style="color: #00a3e0"></i>
                  <!-- Mix -->
                </button>
                <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-xing" style="color: #006567"></i>
                  <!-- Xing -->
                </button>
                <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer">
                  <i class="fab fa-line" style="color: #00b900"></i>
                  <!-- Line -->
                </button>
              </div>
              <div class="p-top-16 p-r-40">
                <p class="text_style_10" [innerHtml]="patent.header_subtitle"></p>
                <p class="text_style_9 p-top-16" [innerHtml]="patent.header_description"></p>
              </div>
            </div>
          </div>

          <ng-container *ngFor="let list of patent.lists">
            <div class="consultancy_bottom_content_box1">
              <div>
                <span class="text_blue_10" [innerHtml]="list.title"></span>
              </div>
              <div class="p-top-16">
                <ul class="checkmate-list" style="list-style: none; padding-left: 0;">
                  <li *ngFor="let item of list.keyWords" class="text_style_10"
                    style="background: url('../../../assets/icons/tick_icon.png') no-repeat left center; padding-left: 25px; margin-bottom: 10px;"
                    [innerHtml]="item">
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>

          <ng-container *ngFor="let section of patent.body">
            <div class="bottom_border_trans p-y-60 consultancy_bottom_content_box3 p-x-10">
              <div *ngIf="section.body_title">
                <span class="text_blue_10" [innerHtml]="section.body_title"></span>
              </div>
              <div class="text_style_10 p-top-16 text_align-justify" *ngIf="section.body_description">
                <span [innerHtml]="section.body_description"></span>
              </div>

              <div class="p-top-16 consultancy_bottom_content_box3_body3 " *ngIf="section.body_keypoints?.length">
                <ul class="f-16 row consultancy_bottom_content_box3_body3_item3">
                  <li class="consultancy_bottom_content_box3_body3_item3_list3 p-top-40"
                    *ngFor="let item of section.body_keypoints">
                    <img *ngIf="item.keypoints_icon" [src]="imageBaseUrl + item.keypoints_icon"
                      alt="{{ item.keypoints_title }}" class="item-icon" />
                    <div class="item-content">
                      <strong class="text_blue_1" *ngIf="item.keypoints_title"
                        [innerHtml]="item.keypoints_title"></strong>
                      <p class="text_style_1 text_align-justify " *ngIf="item.keypoints_description"
                        [innerHtml]="item.keypoints_description"></p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="consultancy_bottom_right">
      <div class="consultancy_bottom_right_sticky">
        <div class="edit_body_heading width-100-per left-border-2">
          <div class="width-100-per">
            <div class="cursor-pointer m-r-3-neg p-x-20 left-border-1" routerLink="/patent-india">
              <div class="p-y-18">
                <span class="text_blue_18">Patent Service</span>
              </div>
            </div>
            <div class="cursor-pointer p-x-20" routerLink="/agro-regulatory">
              <div class="p-y-18">
                <span class="text_black_11">Regulatory Service</span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-top-40">
          <div class="bg_1 border_box border-radius-10">
            <div class="bottom_border_trans p-x-18 p-top-32 p-bot-16">
              <span class="text_blue_1">Download Brochure</span>
            </div>
            <div>
              <ng-container *ngFor="let pdf of pdfFiles">
                <div class="p-y-24 p-x-20 dis-flex-7 bottom_border_trans">
                  <div>
                    <img src="../../../assets/icons/pdf_icon.png" />
                  </div>
                  <div class="p-l-8">
                    <a [href]="pdf.url" target="_blank" class="text_blue_2 text_decoration_none word-break">{{
                      pdf.file_name }}</a>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="inline_padding1 p-y-50">
    <div class="dis-flex-2 p-y-18">
      <div class="text_blue_10">Inquiry Form</div>
    </div>
    <form [formGroup]="InquiryForm" (ngSubmit)="submit_Inquiry_form()">
      <div class="dis-grid-2 text_align contact_bottom_cols_right_name">
        <div class="p-10">
          <label class="text_grey_2">Name</label>
          <input type="text" id="name" formControlName="name"
            class="text_grey_1 height-50 border-radius-4 width-100-per p-x-15" placeholder="James" />
          <div *ngIf="formSubmitted && InquiryForm.controls['name'].invalid">
            <small class="text-red-1">Name is required.</small>
          </div>
        </div>

        <div class="p-10 dis-block-1">
          <label class="text_grey_2">Phone</label>
          <div class="width-100-per">
            <select id="countryCode" formControlName="country_code"
              class="text_grey_1 height-50 border-radius-4 p-x-5 width-20-per">
              <option *ngFor="let country of countries" [value]="country.code">
                {{ country.code }}
                <!-- Only display the code, since img tag cannot be used within an <option> -->
              </option>
            </select>
            <input type="tel" id="phone" formControlName="number"
              class="text_grey_1 height-50 border-radius-4 width-80-per p-x-15" placeholder="932 791 6546" />
            <div *ngIf="formSubmitted && InquiryForm.controls['number'].invalid">
              <small *ngIf="InquiryForm.controls['number'].errors?.['required']" class="text-red-1">Phone number is
                required.</small>
              <small *ngIf="InquiryForm.controls['number'].errors?.['pattern']" class="text-red-1">Phone number must be
                10 digits.</small>
            </div>
          </div>
        </div>
      </div>

      <div class="text_align p-10">
        <label class="text_grey_2">Email</label>
        <input type="email" id="email" formControlName="email"
          class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15" placeholder="james.1978@gmail.com" />
        <div *ngIf="formSubmitted && InquiryForm.controls['email'].invalid">
          <small *ngIf="InquiryForm.controls['email'].errors?.['required']" class="text-red-1">Email is
            required.</small>
          <small *ngIf="InquiryForm.controls['email'].errors?.['email']" class="text-red-1">Invalid email
            format.</small>
        </div>
      </div>

      <div class="text_align p-10">
        <label class="text_grey_2">Subject</label>
        <input type="text" id="subject" formControlName="subject"
          class="text_grey_1 border-radius-4 height-50 width-100-per p-x-15"
          placeholder="Write Subject for inquiry......" />
        <div *ngIf="formSubmitted && InquiryForm.controls['subject'].invalid">
          <small class="text-red-1">Subject is required.</small>
        </div>
      </div>

      <div class="text_align p-10">
        <label class="text_grey_2">Message</label>
        <textarea id="message" formControlName="message" class="text_grey_1 border-radius-4 p-x-20 width-100-per p-x-15"
          placeholder="Write message....." rows="4"></textarea>
        <div *ngIf="formSubmitted && InquiryForm.controls['message'].invalid">
          <small class="text-red-1">Message is required.</small>
        </div>
      </div>

      <!-- <div class=" m-t-20" >
                <re-captcha 
                class="m-t-20"  
                [siteKey]="recaptchaSiteKey" 
                formControlName="recaptcha">
              </re-captcha>
            </div> -->
      <div class="m-t-20">
        <re-captcha class="m-t-20" [siteKey]="recaptchaSiteKey" (resolved)="onCaptchaSuccess($event)">
        </re-captcha>
        <div *ngIf="formSubmitted && !recaptchaResponse">
          <small class="text-red-1">Please complete the reCAPTCHA.</small>
        </div>
      </div>
      <div>
        <button type="submit" class="rounded-pill text_white_1 button_blue_1 m-t-20 dis-block-1">
          <span class="button_blue_1_text">Send Message</span>
          <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" />
        </button>
      </div>

      <!-- <div *ngIf="errorMessage" class="error-message text-red-1">
          {{ errorMessage }}
        </div> -->
    </form>
  </div>
</div>

<app-footer />